<template>
    <div  class="q-pt-xl q-pb-xl">
        <q-card class="content-wrapper q-pr-xl q-pb-xl q-pl-xl q-pt-xs bg-grey-3" style="border-radius: 20px;">
   
        <div class="row top-title">
            <div class="col-xs-12 col-sm-12 col-md-12">
                <q-chip size="24px" rounded color="primary" text-color="white">Acknowledgement</q-chip>
            </div>
        </div>

            <q-card class="q-pa-sm bg-white" style="border-radius: 20px;">
                <q-separator spaced />
                    <GateWayFail v-if="TC_TransactionStatus!='0000'"
                        :TC_TransactionStatus=TC_TransactionStatus
                        :TC_Reason=TC_Reason 
                    />
                    <GateWaySuccess v-if="TC_TransactionStatus==='0000'"
                     :TC_TransactionStatus=TC_TransactionStatus
                        :TC_Reason=TC_Reason 
                    />
                    <ApplicantDetail 
                        :InvestorName=InvestorName
                        :ReferenceID=ReferenceID
                        :AccountNo=AccountNo
                        :AccountType=AccountType
                    />
                    <TrnxDetail
                    :currentDateTime=currentDateTime
                    :TrxType=TrxType
                    :redeemArray=redeemArray
                    :switchArray=switchArray
                    :investArray=investArray
                    />
                    <div class="row">
                        <div class="column items-justify paddingHolder">
                            <div class="col-6 col-xs-12 col-sm-2 col-md-2 column items-justify">
                                <a class="text-body1">For further assistance, please call our hotline at 1-800-88-7080</a>
                            <!--     <a class="text-body1">Our Location : Menara Boustead 69, Ground Floor, Jalan Raja Chulan,Bukit Ceylon, 50200 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur</a>
                             -->
                            </div>
                        </div>
                    </div> 
                     <div class="row">
                        <div class="column items-justify paddingHolder">
                            <div class="col-6 col-xs-12 col-sm-2 col-md-2 column items-justify">
                                <a class="text-body1">Our Location : Menara Boustead 69, Ground Floor, Jalan Raja Chulan,Bukit Ceylon, 50200 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur</a>
                            </div>
                        </div>
                    </div>        
                <!-- <div class="column items-center paddingHolder">
                    <div class="col">
                        <a class="text-caption">If you do not received the email by 5p.m today or the next business day, kindly contact our Customer Care Consultant to confirm the status of yor online transaction at 1800-88-7080 (8.45am to 5.30 pm- Monday to Friday).</a>
                    </div>
                </div> -->
            </q-card>
                <q-card-actions  align="center">
                   <!--  <q-btn type="button" label="Close" class="btnHolder q-mr-sm" color="negative" text-color="white" no-caps @click="cancel()" icon="fas fa-window-close"  /> -->
                    <q-btn type="button" label="Download" class="btnHolder q-mr-sm" color="primary" text-color="white" no-caps @click="PrintFunction()" icon="fas fa-download" />
                  
                </q-card-actions>          
            </q-card>

    </div>
</template>

<script>
import { QForm, QCard, QCardSection, QLinearProgress, Notify , QToggle, QInput, QSelect, QDialog, Loading} from 'quasar'

import axios from 'axios'
import GateWayFail from './GateWayFail.vue'
import GateWaySuccess from './GateWaySuccess.vue'
import ApplicantDetail from './ApplicantDetail.vue'
import TrnxDetail from './TrnxDetail.vue'

export default {
    name: 'Acknowledgement',
    components: {
        GateWayFail,
        GateWaySuccess,
        ApplicantDetail,
        TrnxDetail,
        QForm,
        QCard,
        QCardSection,
        QLinearProgress,
    },
    props: {
    /* */   TC_TransactionStatus: { type: String, required: true },
    TC_Reason: { type: String, required: true },
    InvestorName: { type: String, required: true },
    ReferenceID: { type: String, required: true },
    AccountNo: { type: String, required: true },
    AccountType: { type: String, required: true }, 
    TrxType: {type: String, required:true},
    Transaction: {type:Array, required:true}        
  }, 
    data () {
        return {
            redeemArray:[],
            switchArray:[],
            investArray:[],
            currentDateTime:'',

           /*  AccountNo:"010002679590",
            AccountType:"UTF",
            InvestorName:"THEONG TEK HOCK",
            ReferenceID:"445917EF24",
            TC_Reason:"Pending Process",
            TC_TransactionStatus:"0000",
            TrxType:"Online Redemption",
            Transaction:{
                            Investment:[],
                            Switching:[],
                            Redemption:[
                                { 
                                    AmountOrUnit:"unit",
                                    BankAccountNumber:"e",
                                    FundCode:"SAOFHCF",
                                    FundCurrency:"MYR",
                                    FundID:"GOF",
                                    FundName:"Affin Hwang Select Asia (ex Japan) Opportunity Fund - MYR",
                                    Id:"53e28e17-6c1b-4086-b7be-fb8dc6e07305",
                                    PaymentInstruction:"Telegraphic / Interbank Transfer",
                                    Plan:"CS",
                                    TypeOfProduct:"CS",
                                    Units:22222.22,
                                    accountId:"010002679590",
                                    doclink:"https://nadiablob.blob.core.windows.net/funddoc/Jan-2020%2FSAOFHCF%2FPSIM_SAOFHCF.pdf",
                                    cutOffTime:"16:30:00"
                                }
                            ]
                    } */
        }
    },
    methods:{
    
        message(title, body){
            this.$q.dialog({
                title : title,
                message : body
            })
        },
        showLoading(){
            this.$q.loading.show({
                spinnerSize : 50
            })
        },
        hideLoading(){
            this.$q.loading.hide()
        },
        SuccessMsg(body) {
            this.$q.notify({
                type: 'info',
                message: body
            })
        },
        sendEmail:function(base64String){

                console.log(base64String)
            axios({
                method: "post",
                url: 'https://connectapiuat.nadia.com.my/notification',
                headers: { Authorization: "Bearer v3s9uunyx8pbgptgc33vwrc7"  },
                //sex2qp7ssmvzpb27xghuxskn
                data : {
                    "Application": "test",
                    "NotificationType": "email",
                        "email": {
                        "serviceId": "1",
                        "toAddress": "mohan.daramakoday@affinhwangam.com",                        
                        "subject": "test",
                        "body": "test with attachment",
                        "attachments": [
                            {
                                "fileName": "online_redemption.pdf",
                                "content": base64String,
                                "content-type": "application/*"
                            }
                        ]
                    }
                }
            })
            .then(function (response) {
                console.log(response)
                
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        PrintFunction: function() {
            this.showLoading();
            var TS = ''
            if(this.TC_TransactionStatus === "0000"){
                TS="Request Submitted Successfully"
            }else{
                TS="Request Submitted Failed"
            }

            let PrintObjt = {
                InvestorName:this.InvestorName,
                ReferenceID:this.ReferenceID,
                AccountNo:this.AccountNo,
                AccountType:this.AccountType,
                TransactionStatus:TS,
                TransactionReason: this.TC_Reason,
                currentDateTime: this.currentDateTime,
                Redemption:this.redeemArray,
                Switching:this.switchArray,
                Investment:this.investArray
            }

            console.log(PrintObjt)

          
            var vm= this;
             axios({
                method: "post",
                url: "https://myjsreport.nadia.com.my/api/report",
                headers: {
                    Authorization: "Basic YWRtaW46cGFzc0B3b3JkMQ==",
                    "Content-Type": "application/json"
                },
                data: {
                    template: {shortid: "SJgE_Dy4OU"},
                    data: {
                        PrintObjt:PrintObjt
                    }
                },
                responseType: "arraybuffer"
            })
            .then(function (response) {
                /* console.log(response.data)

                let TYPED_ARRAY = new Uint8Array(response.data);
                const STRING_CHAR = TYPED_ARRAY.reduce((data, byte)=> {
                     return data + String.fromCharCode(byte);
                }, '')
                let base64String = btoa(STRING_CHAR);

                vm.sendEmail(base64String) */

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'online_redemption_'+vm.currentDateTime+'.pdf'); //or any other extension
                document.body.appendChild(link);
                link.click(); 

                vm.$emit('print', {
                    status: 'success',
                    obj: response,
                    trxDateTime:vm.currentDateTime
                })
                vm.hideLoading();

            })
            .catch(error => {
                vm.hideLoading();
                console.log("jsreport error: " + error);
            }); 
        },
      

    },
        
    mounted() {
        
         
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
    
    
            var d = new Date();
            var hours = d.getHours();
            var minutes = d.getMinutes();
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0'+minutes : minutes;

            var seconds = today.getSeconds()
            if(seconds < 10){
                seconds = '0'+seconds
            }
        // var minutes =  today.getMinutes()
        /*  if(minutes < 10){
                minutes = '0'+minutes
            } */
            //var hours =  today.getHours()
            if(hours < 10){
                hours = '0'+hours
            }

            var currentTime =  hours + ':' + minutes  + ":" + seconds + ' ' + ampm;
        
            this.currentDateTime = dd +'/' + + mm + '/' + yyyy  + ' ' + currentTime;
            
            this.redeemArray=[];
            this.switchArray=[];
            this.investArray=[];

            if(this.Transaction.Redemption.length>0){
                for(var j=0; j<this.Transaction.Redemption.length; j++){
                    this.redeemArray.push({
                        AmountOrUnit:this.Transaction.Redemption[j].AmountOrUnit,
                        BankAccountNumber:this.Transaction.Redemption[j].BankAccountNumber,
                        FundCode:this.Transaction.Redemption[j].FundCode,
                        FundCurrency:this.Transaction.Redemption[j].FundCurrency,
                        FundID:this.Transaction.Redemption[j].FundID,
                        FundName:this.Transaction.Redemption[j].FundName,
                        Id:this.Transaction.Redemption[j].Id,
                        PaymentInstruction:this.Transaction.Redemption[j].PaymentInstruction,
                        Plan:this.Transaction.Redemption[j].Plan,
                        TypeOfProduct:this.Transaction.Redemption[j].TypeOfProduct,
                        Units:this.Transaction.Redemption[j].Units,
                        accountId:this.Transaction.Redemption[j].accountId,
                        cutOffTime:this.Transaction.Redemption[j].cutOffTime
                    })
                }
            }
            if(this.Transaction.Investment.length>0){
                for(var j=0; j<this.Transaction.Investment.length; j++){
                    this.investArray.push({
                        AmountOrUnit:this.Transaction.Investment[j].AmountOrUnit,
                        BankAccountNumber:this.Transaction.Investment[j].BankAccountNumber,
                        FundCode:this.Transaction.Investment[j].FundCode,
                        FundCurrency:this.Transaction.Investment[j].FundCurrency,
                        FundID:this.Transaction.Investment[j].FundID,
                        FundName:this.Transaction.Investment[j].FundName,
                        Id:this.Transaction.Investment[j].Id,
                        PaymentInstruction:this.Transaction.Investment[j].PaymentInstruction,
                        Plan:this.Transaction.Investment[j].Plan,
                        TypeOfProduct:this.Transaction.Investment[j].TypeOfProduct,
                        Units:this.Transaction.Investment[j].Units,
                        accountId:this.Transaction.Investment[j].accountId,
                        cutOffTime:this.Transaction.Investment[j].cutOffTime
                    })
                }
            }

            if(this.Transaction.Switching.length>0){
                for(var j=0; j<this.Transaction.Switching.length; j++){
                    this.switchArray.push({
                        AmountOrUnit:this.Transaction.Switching[j].AmountOrUnit,
                        BankAccountNumber:this.Transaction.Switching[j].BankAccountNumber,
                        FundCode:this.Transaction.Switching[j].FundCode,
                        FundCurrency:this.Transaction.Switching[j].FundCurrency,
                        FundID:this.Transaction.Switching[j].FundID,
                        FundName:this.Transaction.Switching[j].FundName,
                        Id:this.Transaction.Switching[j].Id,
                        PaymentInstruction:this.Transaction.Switching[j].PaymentInstruction,
                        Plan:this.Transaction.Switching[j].Plan,
                        TypeOfProduct:this.Transaction.Switching[j].TypeOfProduct,
                        Units:this.Transaction.Switching[j].Units,
                        accountId:this.Transaction.Switching[j].accountId,
                        cutOffTime:this.Transaction.Switching[j].cutOffTime
                    })
                }
            }
    }
}
</script>

<style scoped>
.top-title {
  position: relative;
  top: -30px;
  z-index: 1;
  text-align: center;
  font-weight: bold;
}

.paddingHolder{
    color: #59599e;
    padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom:10px;
}
@media only screen and (max-width: 599px) {
  .content-wrapper {
    padding: 0 !important;
    margin: 0 !important;
  }
}


@media print {
    @page {
        size: auto;
        margin: 0mm; 
    }

    .btnHolder{
        display: none;
    }
    
}
</style>